import type {ID} from "app/utils/types";
import {query} from "app/gql/client";
import {
  MarkAllInAppNotificationsAsReadAndReloadDocument,
  MarkInAppNotificationAsReadAndReloadDocument
} from "app/gql/graphqlSchema";

export const markAsReadInAppNotificationAndReload = async (deliveryId: ID) =>
  (await query(MarkInAppNotificationAsReadAndReloadDocument, {id: deliveryId})).markInAppNotificationAsRead
    .inAppNotifications;

export const markAllAsReadInAppNotificationsAndReload = async () =>
  (await query(MarkAllInAppNotificationsAsReadAndReloadDocument, {})).markAllInAppNotificationsAsRead
    .inAppNotifications;
